import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { ShowcaseType } from '../enums/ShowcaseType'
import type { ShowcaseTranslationEntity } from './ShowcaseTranslationEntity'
import type { ScopeType } from '../enums/ScopeType'
import type { ShowcaseModeType } from '../enums/ShowcaseModeType'
import type { ShowcaseDesign } from '../enums/ShowcaseDesign'

export class ShowcaseEntity {
  id?: number
  order?: number
  type?: ShowcaseType
  channel?: ChannelMiniEntity | null
  translations?: Array<ShowcaseTranslationEntity> | null
  channelName?: string
  startDate?: string | null
  endDate?: string | null
  disabled?: boolean
  scopeType?: ScopeType
  showcasePerBranch?: number
  isShiftIgnored?: boolean
  mode?: ShowcaseModeType
  design?: ShowcaseDesign
}
